<template>
  <el-select @change="handleChange" popper-class="cust-select-poper" v-model="accessType"  style="width: 100%">
        <el-option :label="$t('ALL_OPTION')" value="ALL" >
            <p >
                <el-radio class="mr_10 label-hidden" label="ALL" v-model="accessType" ></el-radio>
                <span class="option-label">{{$t('ALL_OPTION')}}</span>
            </p>
            <template v-if="$i18n.locale === 'en'">
                <p class="mr_25 desc" >
                    User has access to all components content in 'Group Reporting' tile.  
                </p>
                <!-- <p class="mr_25 desc">tiles and all content there.</p> -->
            </template>
            <template v-else>
                <p class="mr_25 desc">用户可以访问“集团审计”版块中所有组成部分的内容。</p>
            </template>
           
        </el-option>
        <el-option  :label="$t('SPECIFIC_OPTION2')" value="SPECIFIC">
            <p >
                <el-radio class="mr_10 label-hidden" label="SPECIFIC"  v-model="accessType"></el-radio>
                <span class="option-label">{{$t('SPECIFIC_OPTION2')}}</span>
            </p>
             <template v-if="$i18n.locale === 'en'">
                <p class="mr_25 desc">
                    User has access to the content of authorised components
                </p >
                <p class="mr_25 desc"> in “Group Reporting” tile.</p>
            </template>
            <template v-else>
                  <p class="mr_25 desc">用户可以访问“集团审计”版块中所授权组成部分的内容。</p>
            </template>
           
        </el-option>
    </el-select>
</template>

<script>
export default {
    props:{
        initData:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            accessType:"",
        }
    },
    watch:{
       initData:{
            handler:function(val){
                this.accessType =val;
            },
            immediate:true
       } 
    },
    methods:{
        
        handleChange(){
            this.$emit("change", this.accessType)
        }
    }
}
</script>

<style scoped>
    .mr_10{
    margin-right:10px;
    }
    .mr_25{
        margin-left:25px;
    }
    .desc{
        color:#636363;
        font-weight:400;
    }
    ::v-deep .label-hidden .el-radio__label{
        display: none;
    }
</style>